<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">转出状态：</div>
          <Select
            class="height45"
            v-model="transferStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in transferStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <Input
            class="height45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="transferStatus" slot-scope="{ row }">
          <div>
            {{ row.transferStatus | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.transferStatus === 1">
            <Button @click="onGetCodeAgain(row.id)">重新获取转移码</Button>
            <Button @click="onDeleteItem(row.id)">取消</Button>
          </div>
          <div v-else-if="row.transferStatus === 2">
            <Button @click="onAgreeItem(row.id)">同意</Button>
            <Button @click="onDeleteItem(row.id)">取消</Button>
            <Button @click="onCheckStatus(row.id, row.dn)">查询状态</Button>
          </div>
          <div v-else-if="row.transferStatus === 4 && row.reason != null">
            <Button @click="checkReason(row.reason)">原因</Button>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTransferOutList,
  transferOutRefreshCode,
  transferOutCancel,
  transferOutConsent,
  transferOutQueryStatus,
} from "api/domain.js";
export default {
  name: "transferoutRecord",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 1:
          title = "待转出";
          break;
        case 2:
          title = "转出中";
          break;
        case 3:
          title = "转出成功";
          break;
        case 4:
          title = "转出失败";
          break;
        case 5:
          title = "用户取消";
          break;
        case 6:
          title = "转入商拒绝";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      transferStatus: "",
      transferStatusList: [
        {
          value: 1,
          label: "待转出",
        },
        {
          value: 2,
          label: "转出中",
        },
        {
          value: 3,
          label: "转出成功",
        },
        {
          value: 4,
          label: "转出失败",
        },
        {
          value: 5,
          label: "用户取消",
        },
        {
          value: 6,
          label: "转入商拒绝",
        },
      ],
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "域名",
          align: "center",
          key: "domainName",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdAt",
        },
        {
          title: "转出状态",
          align: "center",
          slot: "transferStatus",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          domainName: this.domainName,
          transferStatus: this.transferStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await getTransferOutList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.transferStatus = "";
      this.onPageChange(1);
    },
    // 重新获取转移码
    onGetCodeAgain(id) {
      this.$Modal.confirm({
        title: "操作确认",
        content: "<p>确定要重新获取转移码吗？</p>",
        onOk: async () => {
          const res = await transferOutRefreshCode({
            id,
          });
          const { code, result, data } = res.data;
          if (code === 200 && result) {
            this.$Modal.success({
              title: "重新获取转移码成功",
              content: data || "-",
            });
          }
        },
      });
    },
    // 取消转出
    onDeleteItem(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消此转出吗？</p>",
        onOk: async () => {
          const res = await transferOutCancel({
            id,
          });
          const { code, result } = res.data;
          if (code === 200 && result) {
            this.$Message.success("取消成功！");
            this.req_getList();
          }
        },
      });
    },
    // 同意转出
    onAgreeItem(id) {
      this.$Modal.confirm({
        title: "同意确认",
        content: "<p>确定要同意此转出吗？</p>",
        onOk: async () => {
          const res = await transferOutConsent({
            id,
          });
          const { code, result } = res.data;
          if (code === 200 && result) {
            this.$Message.success("同意成功！");
            this.req_getList();
          }
        },
      });
    },
    // 查询状态
    async onCheckStatus(id) {
      const res = await transferOutQueryStatus({ id });
      if (res.code === 200) {
        this.$Modal.info({
          title: "当前状态",
          content: res.data ? res.data : "-",
        });
      }
    },
    // 查看原因
    onCheckReason(reason) {
      this.$Modal.warning({
        title: "转出失败原因",
        content: reason,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
